import fr from 'dayjs/locale/fr';
import { dateFnsLocalizer } from 'react-big-calendar';

import { format, getDay, parse, startOfWeek } from 'app/utils/dayjs';

export const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 1 }),
  getDay,
  locales: { fr: fr },
});

export const CALENDAR_CONFIG = {
  STEP: 15,
  TIMESLOTS: 4,
} as const;

export const eventPropGetter = () => ({
  style: {
    backgroundColor: 'transparent',
    border: 'none',
    padding: '2px',
    boxShadow: 'none',
  },
});
